export default {
  title: 'Diversity of services',
  carousel :{
    T1:'Firm with',
    P1:'more than 25 years of experience',
    T2:'We understand the business of each of our clients',
    P2:'We strategically approach the challenges of each company.',
    T3:'Our firm is a member of:',
    P3:'PrimeGlobal is one of the 5 largest associations of independent accounting firms in the world, comprised of approximately 286 highly successful independent public accounting firms in over 88 countries. PrimeGlobal’s independent member firms house a combined total of over 2,338 partners, 22,567 employees.',
    SP3: 'PrimeGlobal is found worldwide, divided into 4 regions: Pacific Asia, Europe, the Middle East and Africa, Latin America, North America.'
  },
  globes:[
    {
      title: 'Countries',
      data: '90',
      image: require('@/assets/iconos/countries.png')
    },
    {
      title: 'Firms',
      data: '288',
      image: require('@/assets/iconos/firms.png')
    },
    {
      title: 'Offices',
      data: '852',
      image: require('@/assets/iconos/offices.png')
    },
    {
      title: 'Revenue',
      data: '$2.93 BILLONES',
      image: require('@/assets/iconos/revenue.png')
    },
    {
      title: 'Member Satisfaction',
      data: '86%',
      image: require('@/assets/iconos/member.png')
    },
    {
      title: 'Staff / Partners',
      data: '26,270',
      image: require('@/assets/iconos/staff.png')
    }
  ],
  principles: {
    title: 'Principles and values guide our actions',
    description: 'In this way we promote that our professionals carry out their work with integrity and passion for excellence and the discipline of reporting in a timely manner.'
  },
  mission: 'We are a Guatemalan firm with more than 25 years of experience, whose mission is to meet the needs of our clients, providing them with a service of high quality standards and commitment through our staff with high professional skills.',
  vision: 'To be a market leading firm that may provide a strong basis confidence to our clients and employment opportunities to more Guatemalans.',
  values: [
    {
      title : 'Integrity',
      description : 'It is the main value that highlights our firm and our work team. We act correctly in the different situations in which we present ourselves according to the rules, statutes and quality controls that we have established.',
    },
    {
      title : 'Passion for excellence',
      description : 'We are professionals who love what we do and always seek to achieve excellence in our results with clients. We commit ourselves and focus on our work to comply with full satisfaction the requirements of our customers.',
    },
    {
      title : 'Discipline',
      description : 'We are known for our high level of commitment to follow the different role models that govern the firm in order to achieve the potential and the effective development of our skills.',
    },
    {
      title : 'Openness',
      description : 'We are completely open in our work, results, and behavior. We show ourselves full openness before our clients and new business opportunities.',
    },
    {
      title : 'Empathy',
      description : 'We show empathy and we understand the needs of our clients, authorities and colleagues.',
    },
    {
      title : 'Respect',
      description : 'We highly promote respect as a value that allows us to live in harmony.',
    }
  ],
  images:[
    {
      title: 'Advice and consultancy',
      img: require('@/assets/iconos/ico_4.svg')
    },
    {
      title: 'Audit',
      img: require('@/assets/iconos/ico_5.svg')
    },
    {
      title: 'Sworn translation',
      img: require('@/assets/iconos/ico_6.svg')
    },
    {
      title: 'Seminars',
      img: require('@/assets/iconos/ico_7.svg')
    },
    {
      title: 'Recruitment',
      img: require('@/assets/iconos/ico_8.svg')
    },
    {
      title: 'Outsourcing',
      img: require('@/assets/iconos/ico_9.svg')
    },
    {
      title: 'Technology and systems',
      img: require('@/assets/iconos/ico_10.svg')
    },
    {
      title: 'Taxes and legal',
      img: require('@/assets/iconos/ico_11.svg')
    }
  ],
  control: {
    title:'Quality assurance',
    description : 'We work with strict quality standards and rigor, which allow us to optimize risk management, business preservation and contribute to the formalization of reliable businesses.'
  },
  confidentiality: {
    title: 'Confidentiality',
    description : 'We understand that providing private information about the company (ies) carries certain responsibility, mainly for the Professional Ethics of our firm and our professionals.',
    subdescription : 'We show our complete readiness of respecting and relying on our client’s internal produces regarding confidentiality.',
  }
}



// WEBPACK FOOTER //
// ./src/text/en/home.js